import {Component, NgZone} from '@angular/core';
import {NavController, ViewController, Platform} from 'ionic-angular';
import {Http, Response} from '@angular/http';

declare var google: any;

import * as _ from 'lodash';
import {LatLng} from "@ionic-native/google-maps";

@Component({
    selector: 'page-map',
    templateUrl: 'map.html'
})
export class MapPage {

    options: any;
    stateCenters: any;
    state: any;
    stations: any;
    station: any;
    allOverlays: any;
    filteredOverlays: any;

    map: any; // google.maps.Map

    constructor(public navCtrl: NavController,
                public viewCtrl: ViewController,
                private zone: NgZone,
                private http: Http,
                public platform: Platform) {
        // set options to 'All' stateCenter - this doesn't seem to do anything;
        // map appears to auto-zoom to show all created markers...
        this.options = {
            center: {lat: 42.5000, lng: -75.7000},
            zoom: 6
        };

        this.initStates();

        // register a global function that will call the stationSelected method in this component
        // when a button in the infoWindow is clicked
        window['selectStationMap'] = {
            zone: this.zone,
            selectStation: (value) => this.stationSelected(value),
            component: this
        };
    }

    setMap(event) {
        //console.log(event.map);
        this.map = event.map;
    }

    // change state filter
    stateSelected() {
        // NB: selected state will contain whitespace!
        const state = this.state.trim();
        // console.log('state selected', state)
        const stateCenter: any = _.find(this.stateCenters, {name: state});
        if (!state || state == 'All') {
            this.filteredOverlays = this.allOverlays;
        } else {
            this.filteredOverlays = _.filter(this.allOverlays, {state: stateCenter.id});
        }

        if (stateCenter && this.map) {
            this.map.setCenter(new LatLng(stateCenter.lat, stateCenter.lon));
            this.map.setZoom(stateCenter.zoom);
        }
    }

    // called when a station is selected from the drop-down list
    stationSelectedFromList() {
        // NB: selected station will contain whitespace!
        const stationName = this.station.trim();
        const station: any = _.find(this.stations, {name: stationName});
        this.viewCtrl.dismiss({id: station.id, title: stationName});
    }

    // called when a station is selected from the map - value format is 'id|title'
    stationSelected(value) {
        const parts = _.split(value, '|');
        this.viewCtrl.dismiss({id: parts[0], title: parts[1]});
    }

    // The user cancelled, so we dismiss without sending data back.
    cancel() {
        this.viewCtrl.dismiss();
    }

    // load list of stations and generate a map marker for each
    ngAfterViewInit() {
        let self = this;
        let url = `https://newa.nrcc.cornell.edu/newaUtil/stateStationList2/goodsr`;

        this.http.get(url)
            .subscribe(function (res: any) {
                self.stations = JSON.parse(res._body).stations;
                self.allOverlays = _.map(self.stations, function (s) {
                    return new google.maps.Marker({
                        position: {lat: s.lat, lng: s.lon},
                        title: s.name,
                        icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
                        id: s.id,
                        elev: s.elev,
                        network: s.network,
                        state: s.state
                    });
                });
                self.filteredOverlays = self.allOverlays.slice(0); // clone array
            });
    }

    // display an InfoWindow for the selected marker, with a button to select the station
    handleOverlayClick(event) {
        const m = event.overlay;
        new google.maps.InfoWindow({
            content: `<strong>${m.title}</strong>
                <br/>State: ${m.state}
                <br/>Network: ${m.network}
                <br/>Elevation: ${m.elev} ft
                <br/><button onclick="window.selectStationMap.selectStation('${m.id}|${m.title}')">Select this Station</button>`
        }).open(event.map, m);
    }

    initStates() {
        this.stateCenters = [
            {id: 'AL', lat: 32.6174, lon: -86.6795, zoom: 7, name: 'Alabama'},
            {id: 'CT', lat: 41.6220, lon: -72.7272, zoom: 8, name: 'Connecticut'},
            {id: 'DE', lat: 38.9895, lon: -75.5051, zoom: 8, name: 'Delaware'},
            {id: 'DC', lat: 38.9101, lon: -77.0147, zoom: 8, name: 'DC'},
            {id: 'IL', lat: 40.0411, lon: -89.1965, zoom: 6, name: 'Illinois'},
            {id: 'ID', lat: 44.0682, lon: -114.742, zoom: 6, name: 'Idaho'},
            {id: 'IA', lat: 42.0753, lon: -93.4959, zoom: 6, name: 'Iowa'},
            {id: 'KY', lat: 37.5347, lon: -85.3021, zoom: 6, name: 'Kentucky'},
            {id: 'ME', lat: 45.3702, lon: -69.2438, zoom: 7, name: 'Maine'}, //no stations
            {id: 'MD', lat: 39.0550, lon: -76.7909, zoom: 7, name: 'Maryland'},
            {id: 'MA', lat: 42.2596, lon: -71.8083, zoom: 7, name: 'Massachusetts'},
            {id: 'MI', lat: 44.3461, lon: -85.4114, zoom: 6, name: 'Michigan'},
            {id: 'MN', lat: 46.2810, lon: -94.3046, zoom: 6, name: 'Minnesota'},
            {id: 'MO', lat: 38.3568, lon: -92.4571, zoom: 6, name: 'Missouri'},
            {id: 'NE', lat: 41.5392, lon: -99.7968, zoom: 6, name: 'Nebraska'},
            {id: 'NH', lat: 43.6805, lon: -71.5818, zoom: 7, name: 'New Hampshire'},
            {id: 'NJ', lat: 40.1907, lon: -74.6733, zoom: 7, name: 'New Jersey'},
            {id: 'NY', lat: 42.9543, lon: -75.5262, zoom: 6, name: 'New York'},
            {id: 'NC', lat: 35.5579, lon: -79.3856, zoom: 6, name: 'North Carolina'},
            {id: 'OH', lat: 40.1905, lon: -82.6707, zoom: 7, name: 'Ohio'},
            {id: 'PA', lat: 40.8786, lon: -77.7985, zoom: 7, name: 'Pennsylvania'},
            {id: 'RI', lat: 41.6762, lon: -71.5562, zoom: 9, name: 'Rhode Island'},
            {id: 'SC', lat: 33.6290, lon: -80.9500, zoom: 6, name: 'South Carolina'},
            {id: 'SD', lat: 43.9169, lon: -100.2282, zoom: 6, name: 'South Dakota'},
            {id: 'UT', lat: 39.4192, lon: -111.9506, zoom: 7, name: 'Utah'},
            {id: 'VT', lat: 44.0688, lon: -72.6663, zoom: 7, name: 'Vermont'},
            {id: 'VA', lat: 37.5229, lon: -78.8531, zoom: 7, name: 'Virginia'},
            {id: 'WV', lat: 38.6409, lon: -80.6230, zoom: 7, name: 'West Virginia'},
            {id: 'WI', lat: 44.6243, lon: -89.9941, zoom: 6, name: 'Wisconsin'},
            {id: 'ALL', lat: 42.5000, lon: -75.7000, zoom: 6, name: 'All States'},
        ];
    }
}



// WEBPACK FOOTER //
// ./src/pages/map/map.ts